import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface Project {
  id: number;
  name: string;
  mode: 'sales' | 'experience';
}

interface ActiveProjectStore {
  projects: Project[];
  activeProjectId: number | null;
  activeProject: Project | null;
  setActiveProjectId: (id: number | null) => void;
  setProjects: (projects: Project[]) => void;
  setActiveProject: (project: Project | null) => void;
  isInitialized: boolean;
}

export const useActiveProject = create<ActiveProjectStore>()(
  persist(
    (set, get) => ({
      projects: [],
      activeProjectId: null,
      activeProject: null,
      isInitialized: false,
      setActiveProjectId: (id) => {
        const activeProject = get().projects.find(p => p.id === id) || null;
        set({ activeProjectId: id, activeProject });
      },
      setProjects: (projects) => {
        const activeId = get().activeProjectId;
        const activeProject = projects.find(p => p.id === activeId) || null;
        set({ projects, activeProject, isInitialized: true });
      },
      setActiveProject: (project) => set({ activeProject: project }),
    }),
    {
      name: 'active-project-storage',
      storage: createJSONStorage(() => localStorage),
       onRehydrateStorage: (state) => {
        if (state) {
            const activeId = state.activeProjectId;
            const activeProject = state.projects.find(p => p.id === activeId) || null;
            state.activeProject = activeProject;
            state.isInitialized = true;
        }
      },
    }
  )
);